// import { useState } from "react";
// import styles from "./UpdateDrawer.module.css";
// import Button from "../../Dealers/Button";
// import { ProgressBar } from "../ProgressBar";
// import { formatDateTime } from "../../../../Utils/Utils";
// import VerticalDropDown2 from "../../FormComponents/VerticalDropDown2";

// export const UpdateDrawer = ({
//   item,
//   mode,
//   show,
//   machine,
//   machineOptions = [],
//   setMachine,
//   onClose,
//   onSave,
//   productionLoader,
//   productionSaveLock,
// }) => {
//   const [productionQty, setProductionQty] = useState("");

//   // console.log("Item Drawer Data ->", item);

//   const canView = ["In Production"].includes(item?.status);

//   const statusConfig = {
//     Completed: {
//       color: "#ffffff",
//       backgroundColor: "#34A853",
//       text: "Completed",
//     },
//     Cancelled: {
//       color: "#ffffff",
//       backgroundColor: "#991B1B",
//       text: "Cancelled",
//     },
//     "Ready For Dispatch": {
//       color: "#ffffff",
//       backgroundColor: "#34A853",
//       text: "Ready For Dispatch",
//     },
//   };

//   const currentStatus = statusConfig[item?.status];

//   const canSaveUpdate = !currentStatus;

//   // ----------------------------------------------

//   if (!item) return null;

//   const handleComplete = () => {
//     setProductionQty(item.pendingQty);
//   };

//   const requiredQty = Number(item.requiredQty) || 0;
//   const producedQty = Number(item.producedQty) || 0;
//   const entryQty = Number(productionQty) || 0;

//   const totalProduced = producedQty + entryQty;
//   const remainingQty = Math.max(requiredQty - totalProduced, 0);
//   const extraQty = Math.max(totalProduced - requiredQty, 0);

//   const handleSave = () => {
//     // Don't allow save for these statuses
//     if (!canSaveUpdate || productionSaveLock.current) {
//       return;
//     }

//     const qty = Number(productionQty);

//     // if (!qty || qty <= 0) {
//     //   show("Enter a valid Production Qty", "error");
//     //   return;
//     // }

//     onSave({
//       item,
//       qty,
//     });
//   };

//   const filteredItemsHistory = (item?.itemsHistory || []).filter((h) => {
//     return h?.itemId === item?.id;
//   });

//   return (
//     <div className={styles.modalOverlay} onClick={onClose}>
//       <div
//         className={`${styles.updateDrawer} ${
//           mode ? styles.updateDrawerDark : ""
//         }`}
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Header */}
//         <div className={styles.drawerHeader}>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 2,
//               minWidth: 0,
//             }}
//           >
//             <h6
//               style={{
//                 margin: 0,
//                 fontSize: 16,
//                 fontWeight: 700,
//                 color: mode ? "#fff" : "#111",
//                 lineHeight: 1.2,
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               Update Production{" "}
//               <span style={{ color: "#4164E3", fontWeight: 700 }}>
//                 ({item?.voucherId} {item?.itemCode && `/ ${item?.itemCode}`})
//               </span>
//             </h6>
//           </div>
//         </div>

//         {/* Body */}
//         <div className={styles.drawerBody}>
//           <div className={styles.infoGrid}>
//             <div className={styles.infoCard}>
//               <span>Required Qty</span>
//               <strong>{requiredQty}</strong>
//             </div>

//             <div className={styles.infoCard}>
//               <span>Produced Qty</span>
//               <strong style={{ color: "#12b76a" }}>{producedQty}</strong>
//             </div>

//             <div className={styles.infoCard}>
//               <span>Pending Qty</span>
//               <strong
//                 style={{
//                   color: item.pendingQty > 0 ? "#f04438" : "#12b76a",
//                 }}
//               >
//                 {item.pendingQty}
//               </strong>
//             </div>
//           </div>

//           <div style={{ marginBottom: 16 }}>
//             <ProgressBar
//               produced={producedQty}
//               required={requiredQty || 1}
//               mode={mode}
//             />
//           </div>

//           {extraQty > 0 ? (
//             <div
//               style={{
//                 fontSize: 12,
//                 fontWeight: 600,
//                 color: "#F79009",
//                 marginBottom: 12,
//               }}
//             >
//               ⚠️ Extra Production: {extraQty} units.
//               <br />
//               Extra production quantity added to order.
//             </div>
//           ) : (
//             remainingQty !== 0 && (
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   color: "#12B76A",
//                   marginBottom: 12,
//                 }}
//               >
//                 ✅ Current qty update to the order and finish for production
//               </div>
//             )
//           )}

//           {remainingQty === 0 && extraQty === 0 && (
//             <div
//               style={{
//                 fontSize: 12,
//                 fontWeight: 600,
//                 color: "#12B76A",
//                 marginBottom: 12,
//               }}
//             >
//               ✅ Required production quantity completed successfully.
//             </div>
//           )}

//           {/* History */}
//           <div>
//             {filteredItemsHistory?.length > 0 && (
//               <>
//                 <div
//                   style={{
//                     fontSize: 13,
//                     fontWeight: 700,
//                     color: mode ? "#fff" : "#111",
//                     marginBottom: 8,
//                   }}
//                 >
//                   📋 Production History ({filteredItemsHistory.length} update
//                   {filteredItemsHistory.length > 1 ? "s" : ""})
//                 </div>

//                 <div
//                   style={{
//                     maxHeight: 180,
//                     overflowY: "auto",
//                     backgroundColor: mode ? "#1B1D21" : "#F5F7FB",
//                     padding: "3px 10px",
//                     borderRadius: 10,
//                   }}
//                 >
//                   {filteredItemsHistory.map((h, idx) => (
//                     <div
//                       key={idx}
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         padding: "7px 0",
//                         borderBottom:
//                           idx !== filteredItemsHistory.length - 1
//                             ? `1px solid ${mode ? "#3b3d43" : "#E5E7EB"}`
//                             : "none",
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 8,
//                         }}
//                       >
//                         <span
//                           style={{
//                             color: "#12B76A",
//                             fontWeight: 700,
//                             fontSize: 14,
//                           }}
//                         >
//                           {h.delta} units
//                         </span>

//                         {h.itemNo && (
//                           <span
//                             style={{
//                               fontSize: 11,
//                               fontWeight: 600,
//                               color: mode ? "#D1D5DB" : "#6B7280",
//                               backgroundColor: mode ? "#292C32" : "#E9EDF5",
//                               padding: "3px 7px",
//                               borderRadius: 5,
//                             }}
//                           >
//                             {h.itemNo}
//                           </span>
//                         )}
//                       </div>

//                       <span
//                         style={{
//                           color: mode ? "#ffffff" : "#6B7280",
//                           fontSize: 11,
//                           fontWeight: 500,
//                           whiteSpace: "nowrap",
//                           marginLeft: 10,
//                         }}
//                       >
//                         {h.updatedBy || "Admin"} /{" "}
//                         {formatDateTime(h.updateTime)}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//           </div>

//           {/* Production Qty */}
//           {canView && (
//             <>
//               <div className={styles.formGroup}>
//                 <label>Add Production Qty</label>

//                 <input
//                   type="text"
//                   inputMode="numeric"
//                   value={productionQty}
//                   onChange={(e) => {
//                     const value = e.target.value;

//                     if (/^\d*$/.test(value)) {
//                       setProductionQty(value);
//                     }
//                   }}
//                   placeholder="Enter qty..."
//                 />
//               </div>

//               <div className={styles.quickBtns}>
//                 <Button
//                   buttonClick={handleComplete}
//                   buttonBgColor={"#4164E3"}
//                   buttonTextColor={"#ffffff"}
//                   buttonText={"Complete"}
//                 />
//               </div>
//             </>
//           )}
//           <VerticalDropDown2
//             height="37px"
//             fontSize="12px"
//             label="Production Line"
//             dropDownText={
//               machineOptions.find((m) => m.value === machine)?.label ||
//               "Select Production Line"
//             }
//             options={machineOptions}
//             value={{
//               label:
//                 machineOptions.find((m) => m.value === machine)?.label ||
//                 "Select Production Line",
//               value: machine,
//             }}
//             onchange={(option) => setMachine(option.value)}
//             disableOpen={false}
//           />
//         </div>

//         {/* Footer */}
//         <div className={styles.drawerFooter}>
//           <Button
//             buttonClick={onClose}
//             buttonText={"Close"}
//             buttonBgColor={"#000000"}
//             buttonTextColor={"#ffffff"}
//           />

//           {/* <Button
//             loading={productionLoader}
//             buttonClick={handleSave}
//             buttonText={"Save Update"}
//             buttonBgColor={"#4164E3"}
//             buttonTextColor={"#ffffff"}
//           /> */}

//           <Button
//             loading={productionLoader}
//             buttonClick={handleSave}
//             buttonText={currentStatus?.text || "Save Update"}
//             buttonBgColor={currentStatus?.backgroundColor || "#4164E3"}
//             buttonTextColor={currentStatus?.color || "#ffffff"}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// ------------------------over produce qty update --------------------------

import { useState } from "react";
import styles from "./UpdateDrawer.module.css";
import Button from "../../Dealers/Button";
import { ProgressBar } from "../ProgressBar";
import { formatDateTime } from "../../../../Utils/Utils";
import VerticalDropDown2 from "../../FormComponents/VerticalDropDown2";

export const UpdateDrawer = ({
  item,
  mode,
  show,
  machine,
  machineOptions = [],
  setMachine,
  onClose,
  onSave,
  productionLoader,
  productionSaveLock,
  onOverSave,
}) => {
  const [productionQty, setProductionQty] = useState("");
  const [showOverProduceInput, setShowOverProduceInput] = useState(false);
  // console.log("Item Drawer Data ->", item);

  const canView = ["In Production"].includes(item?.status);
  const overProduceView =
    item?.voucherStatus === "In Production" && item?.status === "Completed";

  const statusConfig = {
    Completed: {
      color: "#ffffff",
      backgroundColor: "#34A853",
      text: "Completed",
    },
    Cancelled: {
      color: "#ffffff",
      backgroundColor: "#991B1B",
      text: "Cancelled",
    },
    "Ready For Dispatch": {
      color: "#ffffff",
      backgroundColor: "#34A853",
      text: "Ready For Dispatch",
    },
  };

  const currentStatus = statusConfig[item?.status];

  const canSaveUpdate = !currentStatus;

  // ----------------------------------------------

  if (!item) return null;

  const handleComplete = () => {
    setProductionQty(item.pendingQty);
  };

  const requiredQty = Number(item.requiredQty) || 0;
  const producedQty = Number(item.producedQty) || 0;
  const entryQty = Number(productionQty) || 0;

  const totalProduced = producedQty + entryQty;
  const remainingQty = Math.max(requiredQty - totalProduced, 0);
  const extraQty = Math.max(totalProduced - requiredQty, 0);

  const handleSave = () => {
    // Don't allow save for these statuses
    if (!canSaveUpdate || productionSaveLock.current) {
      return;
    }

    const qty = Number(productionQty);

    // if (!qty || qty <= 0) {
    //   show("Enter a valid Production Qty", "error");
    //   return;
    // }

    onSave({
      item,
      qty,
    });
  };

  const handleOverSave = () => {
    // Don't allow save for these statuses
    if (!overProduceView || productionSaveLock.current) {
      return;
    }

    const qty = Number(productionQty);

    // if (!qty || qty <= 0) {
    //   show("Enter a valid Production Qty", "error");
    //   return;
    // }

    onOverSave({
      item,
      qty,
    });
  };

  const filteredItemsHistory = (item?.itemsHistory || []).filter((h) => {
    return h?.itemId === item?.id;
  });

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={`${styles.updateDrawer} ${
          mode ? styles.updateDrawerDark : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className={styles.drawerHeader}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              minWidth: 0,
            }}
          >
            <h6
              style={{
                margin: 0,
                fontSize: 16,
                fontWeight: 700,
                color: mode ? "#fff" : "#111",
                lineHeight: 1.2,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Update Production{" "}
              <span style={{ color: "#4164E3", fontWeight: 700 }}>
                ({item?.voucherId} {item?.itemCode && `/ ${item?.itemCode}`})
              </span>
            </h6>
          </div>
        </div>

        {/* Body */}
        <div className={styles.drawerBody}>
          <div className={styles.infoGrid}>
            <div className={styles.infoCard}>
              <span>Required Qty</span>
              <strong>{requiredQty}</strong>
            </div>

            <div className={styles.infoCard}>
              <span>Produced Qty</span>
              <strong style={{ color: "#12b76a" }}>{producedQty}</strong>
            </div>

            <div className={styles.infoCard}>
              <span>Pending Qty</span>
              <strong
                style={{
                  color: item.pendingQty > 0 ? "#f04438" : "#12b76a",
                }}
              >
                {item.pendingQty}
              </strong>
            </div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <ProgressBar
              produced={producedQty}
              required={requiredQty || 1}
              mode={mode}
            />
          </div>
          {extraQty > 0 ? (
            <div
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#F79009",
                marginBottom: 12,
              }}
            >
              ⚠️ Extra Production: {extraQty} units.
              <br />
              Extra production quantity added to order.
            </div>
          ) : (
            remainingQty !== 0 && (
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#12B76A",
                  marginBottom: 12,
                }}
              >
                ✅ Current qty update to the order and finish for production
              </div>
            )
          )}
          {remainingQty === 0 && extraQty === 0 && (
            <div
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#12B76A",
                marginBottom: 12,
              }}
            >
              ✅ Required production quantity completed successfully.
            </div>
          )}
          {/* History */}
          <div>
            {filteredItemsHistory?.length > 0 && (
              <>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: mode ? "#fff" : "#111",
                    marginBottom: 8,
                  }}
                >
                  📋 Production History ({filteredItemsHistory.length} update
                  {filteredItemsHistory.length > 1 ? "s" : ""})
                </div>

                <div
                  style={{
                    maxHeight: 180,
                    overflowY: "auto",
                    backgroundColor: mode ? "#1B1D21" : "#F5F7FB",
                    padding: "3px 10px",
                    borderRadius: 10,
                  }}
                >
                  {filteredItemsHistory.map((h, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "7px 0",
                        borderBottom:
                          idx !== filteredItemsHistory.length - 1
                            ? `1px solid ${mode ? "#3b3d43" : "#E5E7EB"}`
                            : "none",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span
                          style={{
                            color: "#12B76A",
                            fontWeight: 700,
                            fontSize: 14,
                          }}
                        >
                          {h.delta} units
                        </span>

                        {h.itemNo && (
                          <span
                            style={{
                              fontSize: 11,
                              fontWeight: 600,
                              color: mode ? "#D1D5DB" : "#6B7280",
                              backgroundColor: mode ? "#292C32" : "#E9EDF5",
                              padding: "3px 7px",
                              borderRadius: 5,
                            }}
                          >
                            {h.itemNo}
                          </span>
                        )}
                      </div>

                      <span
                        style={{
                          color: mode ? "#ffffff" : "#6B7280",
                          fontSize: 11,
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                          marginLeft: 10,
                        }}
                      >
                        {h.updatedBy || "Admin"} /{" "}
                        {formatDateTime(h.updateTime)}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          {/* Production Qty */}
          {canView && (
            <>
              <div className={styles.formGroup}>
                <label>Add Production Qty</label>

                <input
                  type="text"
                  inputMode="numeric"
                  value={productionQty}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (/^\d*$/.test(value)) {
                      setProductionQty(value);
                    }
                  }}
                  placeholder="Enter qty..."
                />
              </div>

              <div className={styles.quickBtns}>
                <Button
                  buttonClick={handleComplete}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonText={"Complete"}
                />
              </div>
            </>
          )}

          {overProduceView && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: 10,
                marginTop: 10,
              }}
            >
              <button
                type="button"
                onClick={() => {
                  setShowOverProduceInput((prev) => !prev);
                  if (showOverProduceInput) {
                    setProductionQty("");
                  }
                }}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  color: showOverProduceInput ? "#F93E3E" : "#4164E3",
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {showOverProduceInput ? "Cancel More Qty" : "+ Add More Qty"}
              </button>

              {showOverProduceInput && (
                <div className={styles.formGroup} style={{ width: "100%" }}>
                  <label>Add Production Qty</label>

                  <input
                    type="text"
                    inputMode="numeric"
                    value={productionQty}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (/^\d*$/.test(value)) {
                        setProductionQty(value);
                      }
                    }}
                    placeholder="Enter extra qty..."
                  />
                </div>
              )}
            </div>
          )}

          <VerticalDropDown2
            height="37px"
            fontSize="12px"
            label="Production Line"
            dropDownText={
              machineOptions.find((m) => m.value === machine)?.label ||
              "Select Production Line"
            }
            options={machineOptions}
            value={{
              label:
                machineOptions.find((m) => m.value === machine)?.label ||
                "Select Production Line",
              value: machine,
            }}
            onchange={(option) => setMachine(option.value)}
            disableOpen={false}
          />
        </div>

        {/* Footer */}
        <div className={styles.drawerFooter}>
          <Button
            buttonClick={onClose}
            buttonText={"Close"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
          />

          {overProduceView ? (
            <Button
              loading={productionLoader}
              buttonClick={handleOverSave}
              buttonText={"Save Update"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
            />
          ) : (
            <Button
              loading={productionLoader}
              buttonClick={handleSave}
              buttonText={currentStatus?.text || "Save Update"}
              buttonBgColor={currentStatus?.backgroundColor || "#4164E3"}
              buttonTextColor={currentStatus?.color || "#ffffff"}
            />
          )}
        </div>
      </div>
    </div>
  );
};
